let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("3sRE0")).then(() => parcelRequire('7DZFQ'));